<template>
  <div id="Meirichanglongtongji">
    <Tabs type="card" @on-click="tabChange">
      <TabPane v-for="(it, i) in menus" :name="it" :key="i" :label="it">
        <div class="tr-table-container">
          <div class="cl_content">
            <span>该页面统计长龙每天出现的条数，例如某日连续开出5期长龙（该形态）共出现10次</span>
          </div>
          <div class="checked">
            <span
              :class="{'checked_button': key == formatKey(it)}"
              class="handle"
              @click="handleBallChecked(it)"
              v-for="(it, i) in balls"
              :key="i"
              :label="it"
            >{{it}}</span>
          </div>
        </div>
        <div class="tr-table-container">
          <Table width="100%" :columns="columns" :data="visiableData" border></Table>
        </div>
      </TabPane>
    </Tabs>
    <Spin size="large" v-if="isLoading" fix></Spin>
  </div>
</template>

<script>
import columns from "./columns";
import dayjs from "dayjs";
import format from "../../../helpers/format.js";

export default {
  name: "Meirichanglongtongji",
  data() {
    return {
      isLoading: false,
      menus: null,
      balls: null,
      columns: [],
      pageSize: 30,
      dataSource: [],
      visiableData: [],
      maxPeriods: "", //最大长龙期数
      key: "", // 第几球/总和
      chilKey: "single" // 什么长龙 大小单双
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    }
  },
  async created() {
    await this.initData();
    await this.getDate();
  },
  methods: {
    formatName(key) {
      var o = {
        单长龙: "single",
        双长龙: "double",
        大长龙: "big",
        小长龙: "small",
        龙长龙: "long",
        虎长龙: "hu",
        尾大长龙: "tailBig",
        尾小长龙: "tailSmall",
        合双长龙: "comDouble",
        合单长龙: "comSingle"
      };
      return o[key];
    },
    formatKey(key) {
      var o = {
        第一球: "ball1",
        第二球: "ball2",
        第三球: "ball3",
        第四球: "ball4",
        第五球: "ball5",
        第六球: "ball6",
        第七球: "ball7",
        第八球: "ball8",
        第九球: "ball9",
        总和: "sum"
      };
      return o[key];
    },
    async handleBallChecked(it) {
      this.key = this.formatKey(it);
      this.getVisiableData();
      this.getMaxPeriods();
    },
    tabChange(name) {
      this.chilKey = this.formatName(name);

      if (this.betType === "ssc" || this.betType === "choose5") {
        if (this.chilKey == "long" || this.chilKey == "hu") {
          this.balls = ["第一球"];
          this.key = "ball1";
        } else {
          this.balls = [
            "第一球",
            "第二球",
            "第三球",
            "第四球",
            "第五球",
            "总和"
          ];
        }
      } else if (this.betType === "hpten") {
        if (this.chilKey === "long" || this.chilKey === "hu") {
          this.balls = ["第一球", "第二球", "第三球", "第四球"];
          this.key = "ball1";
        } else if (
          this.chilKey === "tailSmall" ||
          this.chilKey === "tailBig" ||
          this.chilKey === "comDouble" ||
          this.chilKey === "comSingle"
        ) {
          this.balls = [
            "第一球",
            "第二球",
            "第三球",
            "第四球",
            "第五球",
            "第六球",
            "第七球",
            "第八球"
          ];
        } else {
          this.balls = [
            "第一球",
            "第二球",
            "第三球",
            "第四球",
            "第五球",
            "第六球",
            "第七球",
            "第八球",
            "总和"
          ];
        }
      }

      this.getVisiableData();
      this.getMaxPeriods();
    },
    initData() {
      if (this.betType == "ks") {
        this.menus = ["单长龙", "双长龙", "大长龙", "小长龙"];
        this.balls = ["总和"];
        this.key = "sum";
      } else if (this.betType == "hpten") {
        this.menus = [
          "单长龙",
          "双长龙",
          "大长龙",
          "小长龙",
          "龙长龙",
          "虎长龙",
          "合单长龙",
          "合双长龙",
          "尾大长龙",
          "尾小长龙"
        ];
        this.balls = [
          "第一球",
          "第二球",
          "第三球",
          "第四球",
          "第五球",
          "第六球",
          "第七球",
          "第八球",
          "总和"
        ];
        this.key = "ball1";
      } else {
        this.menus = [
          "单长龙",
          "双长龙",
          "大长龙",
          "小长龙",
          "龙长龙",
          "虎长龙"
        ];
        this.balls = ["第一球", "第二球", "第三球", "第四球", "第五球", "总和"];
        this.key = "ball1";
      }
    },
    reset(data) {
      this.columns = columns(this.betType).list(this);
    },
    async getDate() {
      let req = {
        gameType: this.$route.params.gameType
      };
      this.dataSource = [];
      this.isLoading = true;
      let res = await this.$http.post("/queryKcDateReport.do", req);
      if (res.data.returnCode == "0000") {
        this.isLoading = false;
        const data = format.formatJson(res.data.returnList);

        data.forEach(it => {
          this.dataSource.push({ ...it.dragon_json, date: it.date });
        });
        this.getVisiableData();
        this.getMaxPeriods();
        this.reset();
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    },
    //表格数据按需展示
    getVisiableData() {
      this.visiableData = [];
      this.dataSource.forEach(it => {
        const data = it[this.key];
        this.visiableData.push({ ...data, date: it.date });
      });
    },
    //获取当前筛选项最大长龙期数
    getMaxPeriods() {
      let sum = 0;
      for (let i = 0; i < this.visiableData.length; i++) {
        const e = this.visiableData[i][this.chilKey];
        let keys = Object.keys(e);
        for (let j = 0; j < keys.length; j++) {
          const key = keys[j];
          if (Number(key) > Number(sum)) {
            sum = key;
          }
        }
      }
      this.maxPeriods = sum;
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Meirichanglongtongji/index.vue